module.exports = function() {
  return new Worker(__webpack_public_path__ + "8750f0f40c10c3610a7e.worker.js");
};